module.exports = __webpack_public_path__ + "static/media/MPD_Loader.3bf6fcf1.gif";